"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseButtonSize = exports.CloseButtonHoverProps = void 0;
var CloseButtonHoverProps;
(function (CloseButtonHoverProps) {
    CloseButtonHoverProps["Darken"] = "0.2";
    CloseButtonHoverProps["SlightlyDarken"] = "0.8";
    CloseButtonHoverProps["Lighten"] = "2.0";
    CloseButtonHoverProps["None"] = "1.0";
})(CloseButtonHoverProps = exports.CloseButtonHoverProps || (exports.CloseButtonHoverProps = {}));
var CloseButtonSize;
(function (CloseButtonSize) {
    CloseButtonSize["Small"] = "12px";
    CloseButtonSize["Medium"] = "16px";
    CloseButtonSize["Large"] = "20px";
})(CloseButtonSize = exports.CloseButtonSize || (exports.CloseButtonSize = {}));
